import { Link } from 'react-router-dom';

import Button from '@/components/content/button/Button';
import { useAuth } from '@/hooks/useAuth';
import { formatCredits } from '../utils/formatCredits';

import CoinIcon from '@/assets/icons/topbar/coin.svg';

const TRANSACTIONS_PATH = '/transactions';

const CreditsAvailable = ({ to = TRANSACTIONS_PATH }: { to?: string | false }) => {
  const { userInfo, userInfoQuery } = useAuth();
  const creditsValue =
    userInfoQuery.isSuccess && userInfo?.quoins?.available != null
      ? Number(userInfo.quoins.available)
      : null;
  const label = (
    <>
      Credits Available
      <strong>
        {'\u00A0'}
        {formatCredits(creditsValue)}
      </strong>
    </>
  );
  const icon = <CoinIcon width={22} height={22} aria-hidden="true" />;

  if (!to) {
    return (
      <Button variant="outline" leftSection={icon}>
        {label}
      </Button>
    );
  }

  return (
    <Button component={Link} to={to} variant="outline" leftSection={icon}>
      {label}
    </Button>
  );
};

export default CreditsAvailable;
